import React from 'react';
import {Col, Row, Typography} from "antd";
import {Line} from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import moment from "moment";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);



function LineChart({coinHistory, currentPrice, coinName}) {
    const coinPrice = [];
    const coinTimestamp =[];

    for(let i = 0; i < coinHistory?.data?.history?.length; i += 1) {
        coinPrice.push(coinHistory?.data?.history[i].price)

    }

    for (let i = 0; i < coinHistory?.data?.history?.length; i += 1) {
        coinTimestamp.push(moment.unix(coinHistory?.data?.history[i].timestamp).format('YYYY-MM-DD'));
    }
    const data = {
        labels: coinTimestamp,
        datasets: [
            {
                label: 'Price in USD',
                data: coinPrice,
                fill: false,
                backgroundColor: '#0071bd',
                borderColor: '#0071bd',
            },
        ],
    };


    const options = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    };


    return (
        <>
        <Row className={'chart-header'}>
            <Typography.Title level={2} className={'chart-title'}>{coinName} Price Chart</Typography.Title>
            <Col className={'price-container'}>
                <Typography.Title level={5} className={'price-change'}>
                    {coinHistory?.data?.change} %
                </Typography.Title>
                <Typography.Title level={5} className={'current-price'}>
                    Current {coinName} Price: $ {currentPrice}
                </Typography.Title>
            </Col>
        </Row>
            <Line type={"line"} data={data} />
        </>
    );
}

export default LineChart;